import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  casualtyMonitorLength: 0,
  casualtyMonitor: [],
  casualtyMonitorError: "",
  formError: "",
};

export default function CasualtyMonitorReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_CASUALTY_MONITOR:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_CASUALTY_MONITOR:
      return { ...state, saveLoading: action.payload };
    case actions.GET_CASUALTY_MONITOR:
      return {
        ...state,
        casualtyMonitor: action.payload.casualtyMonitor,
        casualtyMonitorLength: action.payload.casualtyMonitorLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.CASUALTY_MONITOR_FAIL:
      return { ...state, casualtyMonitorError: action.payload };
    default:
      return state;
  }
}
